export class Tooltip {
  itemId: string;
  tooltipType: string;
  tooltiptitle: string;
  toolTipDisclaimer?: string;
  tooltipDescription: string;
  tooltipExternalLink = '';
  openinnewTab: true;

  constructor(contentjson?: any) {
    if (contentjson) {
      if (contentjson['itemId']) {
        this.itemId = contentjson['itemId'];
      }
      if (contentjson['toolTipType']) {
        this.tooltipType = contentjson['toolTipType'];
      }
      if (contentjson['toolTipTitle']) {
        this.tooltiptitle = contentjson['toolTipTitle'];
      }
      if (contentjson['toolTipDisclaimer']) {
        this.toolTipDisclaimer = contentjson['toolTipDisclaimer'];
      }
      if (contentjson['toolTipDescription']) {
        this.tooltipDescription = contentjson['toolTipDescription'];
      }
      if (contentjson['toolTipExternalLink']) {
        this.tooltipExternalLink = contentjson['toolTipExternalLink'];
      }
      if (contentjson['openinnewTab']) {
        this.openinnewTab = contentjson['openinnewTab'];
      }
    }
  }
}
